<template>
  <modal
    name="social-proof-custom-orders"
    adaptive
    :pivotY="0.1"
    :width="1000"
    height="auto"
    classes="wf-shadow-xl wf-rounded-lg wf-bg-white wf-p-4"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div>
      <div>
        <label class="wf-font-semibold wf-text-gray-600 wf-text-xs wf-uppercase">Custom orders</label>
        <div :key="index" v-for="(order, index) in customOrders" class="wf-my-4 wf-flex wf-flex-wrap wf--mx-1">
          <div class="wf-flex wf-h-full wf-items-end wf-w-1/12 wf-px-2">
            <button @click.prevent="removeOrder(index)" class="wf-rounded-md wf-text wf-border wf-border-gray-300 wf-leading-none wf-h-8 wf-w-8 wf-mt-6 ">&times;</button>
          </div>
          <div class="wf-w-2/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">first name</label>
            <input
              @input="updateOrder(index, $event.target.value, 'first_name')"
              :value="order.first_name"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
          <div class="wf-w-2/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">last name</label>
            <input
              @input="updateOrder(index, $event.target.value, 'last_name')"
              :value="order.last_name"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
          <div class="wf-w-1/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">city</label>
            <input
              @input="updateOrder(index, $event.target.value, 'city')"
              :value="order.city"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
          <div class="wf-w-1/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">state</label>
            <input
              @input="updateOrder(index, $event.target.value, 'state')"
              :value="order.state"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
          <div class="wf-w-3/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">order created at</label>
            <input
              @input="updateOrder(index, $event.target.value, 'date')"
              :value="order.date"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
          <div class="wf-w-2/12 wf-px-1">
            <label class="wf-text-xs wf-font-bold wf-tracking-wide wf-text-gray-900">product</label>
            <input
              @input="updateOrder(index, $event.target.value, 'product')"
              :value="order.product"
              type="text"
              class="focus:wf-outline-none wf-bg-gray-200 wf-h-8 wf-text-gray-700 wf-rounded-md wf-text-xs wf-px-2 wf-w-full"
            >
          </div>
        </div>
        <div>
          <button @click.prevent="addOrder" class="wf-text-center wf-w-full wf-border wf-border-gray-500 wf-rounded-md wf-text-gray-500 wf-border-dashed wf-h-10 wf-text-xs wf-uppercase wf-font-semibold">
            <i class="fas fa-plus wf-mr-2"></i> add order
          </button>
        </div>
      </div>
      <div class="wf-flex wf-flex-wrap wf-justify-end wf-mt-5">
        <button @click.prevent="$modal.hide('social-proof-custom-orders')" class="wf-h-10 wf-rounded-md hover:wf-shadow-md wf-bg-gray-200 wf-text-gray-700 wf-w-32 wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide">Close</button>
        <button @click.prevent="saveOrders" class="wf-h-10 wf-rounded-md wf-bg-blue-200 wf-text-blue-800 hover:wf-shadow-md wf-w-32 wf-uppercase wf-text-xs wf-font-bold wf-tracking-wide wf-ml-2">Save</button>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    data() {
      return {
        customOrders: []
      }
    },
    methods: {
      updateOrder(orderIndex, value, key) {
        this.$set(this.customOrders[orderIndex], key, value)
      },
      removeOrder(orderIndex) {
        this.customOrders = this.customOrders.filter((order, index) => index != orderIndex)
      },
      addOrder() {
        this.customOrders.push({
          first_name: 'John',
          last_name: 'Doe',
          city: 'Austin',
          state: 'TX',
          date: '2020-01-01 15:00:00',
          product: 'Awesome Product'
        })
      },
      beforeOpen(event) {
        this.customOrders = Array.from([...event.params.customOrders])
      },
      closed() {
        this.customOrders = []
      },
      saveOrders() {
        this.$emit('change', this.customOrders)
        this.$modal.hide('social-proof-custom-orders')
      }
    },
  }
</script>